import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6179806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 flex justify-content-end overflow-hidden" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "col-12 md:col-8" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "col-12 md:col-8" }
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: require(`@/assets/${_ctx.imageName}`),
        alt: "logo-prom",
        class: "md:w-auto w-full"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.text), 1)
    ])
  ], 64))
}